'use client'

import { cn } from '@/lib/utils'
import { Button } from '../ui/button'
import { useEffect, useRef, useState } from 'react'
import React from 'react'
import { useTranslations } from 'next-intl'

const ReadmoreDesc = ({
  description,
  children,
  className,
  expandColor,
}: {
  description?: string
  children?: React.ReactNode
  className?: string
  expandColor?: string
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [shouldShowMore, setShouldShowMore] = useState(false)

  const t = useTranslations()

  const descriptionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const checkHeight = () => {
      if (descriptionRef.current && descriptionRef.current.scrollHeight > 150) {
        setShouldShowMore(true)
      } else {
        setShouldShowMore(false)
      }
    }

    checkHeight()

    window.addEventListener('resize', checkHeight)

    return () => {
      window.removeEventListener('resize', checkHeight)
    }
  }, [])

  return (
    <div className='relative'>
      <div
        className={cn('max-h-32 transition-all ease-out duration-300 overflow-hidden', className, {
          'max-h-[1500px]': isExpanded || !shouldShowMore,
        })}
      >
        <div ref={descriptionRef}>
          {children ? children : <p className='whitespace-pre-wrap'>{description || ''}</p>}
        </div>
      </div>
      {shouldShowMore && (
        <>
          <div
            className={cn(
              'bg-gradient-to-t transition-opacity duration-300 from-sidebar from-20% to-transparent w-full absolute z-0 bottom-8 h-8',
              expandColor,
              {
                'opacity-0': isExpanded,
              },
            )}
          />
          <Button
            variant='link'
            onClick={() => setIsExpanded(!isExpanded)}
            className='z-10 relative'
          >
            {isExpanded ? t('read_less') : t('read_more')}
          </Button>
        </>
      )}
    </div>
  )
}

export default ReadmoreDesc
